import { render, staticRenderFns } from "./physClassification.vue?vue&type=template&id=1be4480e&scoped=true"
import script from "./physClassification.vue?vue&type=script&lang=js"
export * from "./physClassification.vue?vue&type=script&lang=js"
import style0 from "./physClassification.vue?vue&type=style&index=0&id=1be4480e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be4480e",
  null
  
)

export default component.exports